const esMessages = {
  /* 01.General */
  'general.copyright': 'Sistema Nube © Todos los derechos reservados.',
  'general.choose-option': 'Elegir',
  'general.january': 'Enero',
  'general.february': 'Febrero',
  'general.march': 'Marzo',
  'general.april': 'Abril',
  'general.may': 'Mayo',
  'general.june': 'Junio',
  'general.july': 'Julio',
  'general.august': 'Agosto',
  'general.september': 'Septiembre',
  'general.october': 'Octubre',
  'general.november': 'Noviembre',
  'general.december': 'Diciembre',
  'general.date': 'Fecha',
  'general.code': 'Código',
  'general.discount': 'Descuento',
  'general.discountType': 'Tipo',
  'general.couponType': 'Tipo de cupón',
  'general.since': 'Válido Desde',
  'general.until': 'Válido Hasta',
  'general.state': 'Estado',
  'general.amount': 'Importe',
  'general.save': 'Guardar',
  'general.points': 'Puntos',
  'general.datetime': 'Fecha y hora',
  'general.type': 'Tipo',
  'general.detail': 'Detalle',
  'general.actions': 'Acciones',
  'general.adhered': 'Adheridos',
  'general.businesses': 'Comercios',
  'general.destinations': 'Destinos',
  'general.all': 'Todos',
  'general.all-2': 'Todas',
  'general.pay': 'Pagar',
  'general.entities': 'Agencias',
  'general.name': 'Nombre',
  'general.number': 'Número',
  'general.expiration': 'Fecha de Expiración',

  /* 02.Inicio de sesión de usuario, cierre de sesión, registro */
  'user.forgot-password-title': 'Recuperar mi clave de acceso',
  'user.forgot-password-text':
    '<b>¡Antención!</b> Una clave provisoria se le enviará al email con el cúal se ha registrado. En caso de no haberse registrado, dirigirse a la sección de Registro.',
  'user.forgot-password-email': 'Complete su email',
  'user.reset-password-button': 'Quiero mi clave',

  'user.reset-password-title': 'Resetear Clave',
  'user.reset-password-text': 'Elija su nueva clave para iniciar sesión con su usuario',
  'user.new-password-again': 'Nueva clave de nuevo',
  'user.new-password': 'Nueva clave ',
  'user.reset-password': 'Resetear Clave',
  'user.new-password-label': 'Complete su nueva clave',

  'user.login-title': 'Iniciar sesión',
  'user.login-password-text':
    'Complete con sus credenciales y comience a disfrutar de todos los beneficios',
  'user.login-button': 'Ingresar',

  'user.register': 'Registrarse',
  'user.register-text': 'Complete sus datos y comience a disfrutar de todos los beneficios',
  'user.forgot-password-question': '¿Olvidó su contraseña?',
  'user.logout': 'Salir',
  'user.login': 'Iniciar Sesión',
  'user.fullname': 'Nombre y apellido',
  'user.cellphone': 'N° de Móvil',
  'user.recommendationCode': 'Código para referir',
  'user.refererCodeSponsor': 'Código de recomendación',
  'user.birthday': 'Fecha de Nacimiento',
  'user.day': 'Día',
  'user.month': 'Mes',
  'user.year': 'Año',
  'user.document-type': 'Tipo Documento',
  'user.document': 'DNI / Cédula',
  'user.gender': 'Sexo',
  'user.accept': 'Acepto los',
  'user.terms': 'términos y condiciones',
  'user.email': 'Email',
  'user.card': 'Nro Tarjeta',
  'user.password': 'Contraseña',
  'user.register-button': 'Crear cuenta',

  'user.tooltip-document': 'Solo dígitos, sin espacios en blanco o signos',
  'user.tooltip-disabled-document':
    'Si sus datos son incorrectos, deberá solicitar en nuestra cede una actualización manual',
  'user.tooltip-password': 'La contraseña debe tener entre 6 y 11 caracteres alfanuméricos',
  'user.male': 'Masculino',
  'user.female': 'Femenino',
  'user.not-defined': 'No específica',

  'topnav.userLogged.my-account': 'Mi Cuenta',
  'topnav.userLogged.my-card': 'Mi Tarjeta',
  'topnav.userLogged.my-money': 'Mi Dinero',
  'topnav.userLogged.my-discounts': 'Mis Descuentos',
  'topnav.userLogged.my-vouchers': 'Mis Vouchers',
  'topnav.userLogged.my-activity': 'Mi Actividad',
  'topnav.userLogged.my-giftcards': 'Mis Giftcards',
  'topnav.terms': 'Términos y Condiciones',
  'topnav.use-coupon': 'Usar cupón',

  /* 03.Menú */
  'menu.home': 'Home',
  'menu.discounts': 'Descuentos',
  'menu.adheredBusinesses': 'Comercios',
  'menu.destinations': 'Destinos',
  'menu.awards': 'Premios',
  'menu.infoPage': 'Información',

  /* 04.Home */
  'home.latest-awards': 'Últimos Premios',
  'home.latest-discounts': 'Últimos Descuentos',
  'home.adhered-businesses': 'Comercios Adheridos',
  'home.adhered-destinations': 'Destinos Adheridos',

  /* 05.Cards */
  'cards.user.welcome': 'Bienvenido',
  'cards.user.points': 'Puntos',
  'cards.user.money': 'Dinero',
  'cards.user.gameCoins': 'Game Coins',

  /* 06.Benefits */
  'benefits.categories': 'Categorías',
  'benefits.adheredBusinesses': 'Comercios Adheridos',
  'benefits.destinations': 'Destinos Adheridos',
  'benefits.discounts': 'Descuentos',
  'benefits.awards': 'Premios',

  /* 07.Benefit Details */
  'benefit-details.details': 'Detalles',
  'benefit-details.description': 'Descripción',
  'benefit-details.adheredBusiness': 'Comercio Adherido',
  'benefit-details.destination': 'Destino Adherido',
  'benefit-details.category': 'Categoría',
  'benefit-details.without-category': 'Sin Categoría',
  'benefit-details.stock': 'Disponible',
  'benefit-details.required-points': 'Puntos requeridos',
  'benefit-details.required-money': 'Dinero requerido',
  'benefit-details.points': 'Puntos',

  /* 08.Social Media */
  'social-media.whatsapp': 'Whatsapp',
  'social-media.facebook': 'Facebook',
  'social-media.button-facebook': 'Continuar con Facebook',
  'social-media.google-map': 'Google Map',
  'social-media.instagram': 'Instagram',
  'social-media.website': 'Sitio Web',

  /* 09.Validations */
  'validations.required': 'Es requerido',
  'validations.email-required': 'El email es requerido',
  'validations.password-required': 'La contraseña es requerida',
  'validations.email': 'Formato de email inválido',
  'validations.min': 'Debe tener mínimo {min} caracteres',
  'validations.max': 'Debe tener máximo {max} caracteres',
  'validations.accept-terms': 'Debe aceptar los términos y condiciones',
  'validations.accept-oneOf': 'Debe elegir alguno de estos valores: ',
  'validations.award-points': 'No dispones de puntos suficientes para obtener este premio',
  'validations.award-money': 'No dispones del dinero suficiente para obtener este premio',
  'validations.discount-points': 'No dispone de los puntos suficientes para obtener este descuento',
  'validations.discount-money': 'No dispone del dinero suficientes para obtener este descuento',
  'validations.pay-money-required': 'Debe completar el importe a pagar',
  'validations.pay-money': 'No puede pagar un monto que no dispone',
  'validations.money-points': 'No tienes puntos para cambiar',
  'validations.money-slide': 'Debe deslizar para canjear sus puntos',
  'validations.money-selected-points': 'No tienes los puntos seleccionados para cambiar',

  /* 10.Success Messages */
  'success-messages.password-sent': '¡Se ha enviado la clave!',
  'success-messages.check-email': 'Revise la cuenta de email {email}',
  'success-messages.award-exchanged': 'Premio canjeado',
  'success-messages.coupon-saved': 'Descuento obtenido',
  'success-messages.coupon-used': 'Cupón usado',
  'success-messages.voucher-saved': 'Voucher Generado',
  'success-messages.voucher-downloaded': 'Voucher descargado',
  'success-messages.money-loaded': 'Dinero Cargado',
  'success-messages.ok': 'Se guardó correctamente',

  /* 11.Error Pages */
  'error-pages.404-title': '404: No se ha encontrado el club',
  'error-pages.inactive-title': 'Sitio Inactivo',

  /* 12.Error Messages */
  'error-messages.nok': 'Ha ocurrido un error',

  /* 13.Award Exchanges */
  'award-exchange.button': 'Canjear',

  /* 14.Coupons */
  'coupons.button': 'Obtener',
  'coupons.valid-since': 'Cupón válido desde',
  'coupons.valid-until': 'hasta',
  'coupons.code': 'Código de cupón',
  'coupons.show-in-commerce': 'Mostrar en caja',
  'coupons.qr-text':
    'Si el QR es escaneado, el cupón pasará a ser usado. Se perderá definitivamente.',
  'coupons.exchange-online': 'Canje Online',
  'coupons.code-copy':
    'Copiá el código del cupón y pegalo para obtener el descuento correspondiente en la compra.',
  'coupons.use': 'Usar',
  'coupons.use-later': 'Usar luego',

  /* 15.Money */
  'money.exchange-points': 'Canjear puntos por dinero',
  'money.pay': 'Pagar con mi dinero',
  'money.show-voucher': 'Ver voucher',

  /* 16.Activity */
  'activity.monthly-purchases': 'Compras Mensuales',
  'activity.my-interactions': 'Últimos movimientos',

  /* 17.Profile */
  'profile.summary': 'Resumen',
  'profile.personal-data': 'Datos personales',
  'profile.account-data': 'Datos de cuenta',
  'profile.current-money': 'Dinero actual',
  'profile.accumulated-points': 'Puntos acumulados',

  /* 18.Datatable */
  'datatable.processing': 'Procesando...',
  'datatable.zero-records': 'No se encontraron resultados',
  'datatable.empty-table': 'Ningún dato disponible en esta tabla',
  'datatable.loading': 'Cargando...',

  /* 19.Membership */
  'membership.title': 'Debe activar su membresía',
  'membership.title-mp': 'Active su membresía',
  'membership.text':
    'Su usuario se encuentra en estado <b>Pendiente de pago</b>. Para poder utilizar la plataforma con todos sus beneficios debe abonar la membresía.',
};

export default esMessages;
